import React, { FC } from 'react';
import {
  Main,
  Stack,
  UserBookmarksSettings,
  UserDashboardSettings,
  UserFollowedDataObjectGroup,
  UserFollowedDataSubject,
} from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './DashboardSettings.translations.json';
import { Helmet } from 'react-helmet-async';
import { Flex } from 'antd';
import styled from 'styled-components';
import { SectionBreadcrumbs } from '../../common/SectionBreadcrumbs';
import { DASHBOARD_ROUTES } from './Dashboard';

const { addTranslations, useTranslation } = i18nNsFactory('dashboard-settings');
addTranslations(translations);

export const DashboardSettings: FC = () => {
  const { t } = useTranslation();

  return (
    <Main>
      <Main.Col>
        <Main.Header>
          <DashboardHeaderStack>
            <Flex gap="small" align="center" justify="space-between">
              <SectionBreadcrumbs data={t('title')} routes={DASHBOARD_ROUTES} />
            </Flex>
          </DashboardHeaderStack>
          <Helmet>
            <title>{t('title')}</title>
          </Helmet>
        </Main.Header>
        <Main.Content id="dashboard-settings">
          <Flex gap="small" style={{ height: '100%' }}>
            <Flex gap="small" vertical flex={1} style={{ height: '100%' }}>
              <UserFollowedDataObjectGroup />
              <UserFollowedDataSubject />
            </Flex>
            <Flex gap="small" vertical flex={0.5} style={{ height: '100%' }}>
              <UserDashboardSettings />
              <UserBookmarksSettings />
            </Flex>
          </Flex>
        </Main.Content>
      </Main.Col>
    </Main>
  );
};

export const DashboardHeaderStack = styled(Stack)`
  position: sticky;
  left: 52%;
  transform: translateX(-50%);
  margin-inline: -999999px;
  width: 100%;
`;
